<script>
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import compressText from "@cclib/functions/quill/compressText.js";
    import * as m from '@app/paraglide/messages.js';

    /* Compressions makes the event longer which requires us to remove a word from the longest line and move it to a shorter line*/
    const compressEvent = function () {
        if (!eventGroupState[projectState.selected]) {
            return;
        }

        if (
            !eventGroupState[projectState.selected].selected ||
            eventGroupState[projectState.selected].selected.length === 0
        ) {
            return;
        }

        eventGroupState[projectState.selected].selected.forEach(
            (eventIndex, selectedEventIndex) => {
                try {
                    if (
                        !eventGroupState[projectState.selected].events[
                            eventIndex
                        ].text
                    ) {
                        return;
                    }

                    eventGroupState[projectState.selected].events[
                        eventIndex
                    ].text = compressText(
                        eventGroupState[projectState.selected].events[
                            eventIndex
                        ].text,
                        eventGroupState[projectState.selected].maxChars,
                        eventGroupState[projectState.selected].maxLines
                    );

                    if (selectedEventIndex === 0 && window.quillEditor) {
                        if (
                            window.quillEditor.getSemanticHTML() !== eventGroupState[projectState.selected].events[eventIndex].text
                        ) {
                            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
                            window.quillEditor.setContents(delta, "silent");
                            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");
                        }
                    }
                } catch (err) {
                    console.error(err);
                }
            },
        );

        insertHistoryAction({
            name: "compress event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });
    };
</script>

<li class="nav-item" title={m.compress_title()}>
    <a
        class="nav-link"
        href="#!/"
        id="compress-text-btn"
        role="button"
        aria-label={m.compress_aria_label()}
        aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        onclick={compressEvent}
        class:disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0}
        ><i class="bi bi-distribute-horizontal"></i></a
    >
</li>
